import { defaultLocales } from './constants'
import { SchemaVariableDefinition } from './SchemaDefinition'
import { VariableDefinition } from './TypedDefinition'
import { VariableNode } from './TypedNode'
import { VariableModel } from './ViewModel'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface VariablePluginProps {
  /**
   * 多语言设置
   *
   * @default
   * const defaultLocales = {
   *   readonly type: "类型";
   *   readonly id: "唯一标识";
   *   readonly defaultValue: "默认值";
   *   readonly value: "值";
   *   readonly setValue: "设置值";
   * }
   */
  locales?: {
    [K in keyof typeof defaultLocales]?: string
  }
}

export class VariablePlugin implements RehajePlugin {
  visitors?: PluginVisitors = {
    definitions: {
      'Schema.Variable': SchemaVariableDefinition,
      Variable: VariableDefinition
    },
    models: {
      Variable: VariableModel
    },
    nodes: {
      Variable: VariableNode
    }
  }

  constructor(public props: VariablePluginProps = {}) {
    this.props = {
      ...props,
      locales: {
        ...defaultLocales,
        ...props?.locales
      }
    }
  }
}
